import React from 'react'

const LoadingPage = () => (
	<div className="d-flex justify-content-center align-items-center">
		<p>Loading...</p>
	</div>
);

export default LoadingPage;
